import {RootState} from "../../../store";

export const getUserInfoMoods = (state: RootState) => state.userInfoReducer.moods;
